import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import { statByDateDataType } from "../apis/entities/dtos";
import { useTrans } from "../hooks";

interface AppLineChartProps {
    data: statByDateDataType[];
}

const CustomTooltip = ({
    active,
    payload,
    label,
}: {
    active?: boolean;
    payload?: any[];
    label?: string;
}) => {
    const { t } = useTrans();
    if (active && payload && payload.length) {
        return (
            <div
                style={{
                    backgroundColor: "var(--chakra-colors-white)",
                    border: "1px solid var(--chakra-colors-greyT90)",
                    padding: "1rem",
                }}
            >
                <p>{`${t("com.AppLineChart:text.date")}: ${label}`}</p>
                <p>{`${t("com.AppLineChart:text.amount")}: \u20AC ${payload[0].value}`}</p>
                <p>{`${t("com.AppLineChart:text.transaction")}: ${payload[0].payload.count}`}</p>
            </div>
        );
    }
    return null;
};

export const AppLineChart = ({ data }: AppLineChartProps) => {
    const { t } = useTrans();
    return (
        <ResponsiveContainer width="100%" height="100%">
            <LineChart
                data={data}
                margin={{
                    top: 20,
                    right: 10,
                    left: 0,
                    bottom: 0,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="day" />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
                <Legend />
                <Line
                    name={t("com.AppLineChart:text.amount")}
                    type="monotone"
                    dataKey="amount"
                    stroke="var(--chakra-colors-primary)"
                    activeDot={{ r: 8 }}
                />
            </LineChart>
        </ResponsiveContainer>
    );
};
